/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_PAYMENT_BATCHES, GET_PAYMENT_BATCHES } from 'src/actions/paymentBatchActions';

const initialState = {
  items: [],
  total: 0,
  isFetching: false,
  message: ''
};

const paymentBatchReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_PAYMENT_BATCHES: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_PAYMENT_BATCHES: {
      const { paymentBatches, total, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = paymentBatches;
        draft.total = total;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default paymentBatchReducer;
